function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getSectionElement (html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector);
}

function getSectionInnerHTML (html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(
      (button) => button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      if (this.dataset.relatedVariantKey) {
        const linesToUpdate = {
          [this.dataset.key]: 0,
          [this.dataset.relatedVariantKey]: 0
        };
        return this.closest("cart-drawer").massUpdateQuantity(linesToUpdate);
      }
      return this.closest("cart-drawer").updateQuantity(this.dataset.key, 0);
    });
  }
}
customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);

class CartDrawerRemoveBundleButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const linesToUpdate = this.dataset.keys.split(",").reduce((acc, key) => {
        if (key !== "") {
          acc[key] = 0;
        }
        return acc;
      }, {});
      this.closest("cart-drawer").massUpdateQuantity(linesToUpdate);
    });
  }
}
customElements.define("cart-drawer-remove-bundle-button", CartDrawerRemoveBundleButton);

class QuickAddVariant extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerId = document.querySelector("cart-drawer")?.dataset.sectionId;
    this.cartCounterId = document.querySelector("cart-counter")?.dataset.sectionId;
    this.removeVariantsBefore = [];
    if (this.hasAttribute("@remove-variants-before:property")) {
      this.removeVariantsBefore.push({ property: this.getAttribute("@remove-variants-before:property") });
    }
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick.bind(this));
  }

  parseProperties(properties) {
    // Transform properties string (eg: 'propertie1:value1;propertie2:cvalue2') to object
    const propertiesObject = {};
    if (properties) {
      properties.split(";").forEach((property) => {
        const [key, value] = property.split(":");
        propertiesObject[key] = value || "";
      });
    }
    return propertiesObject;
  }

  async removeLinesFromCart(linesToUpdate) {
    const body = {
      updates: linesToUpdate,
    };

    return fetch(`${window.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    });
  }

  async removeVariantsFromCart() {
    const cart = await fetch(`${window.routes.cart_url}.js`).then((res) => res.json());
    const linesToUpdate = {};
    this.removeVariantsBefore.forEach((rule) => {
      if (rule.property) {
        const items = cart.items.filter((item) => !!item.properties[rule.property]);
        for (const item of items) {
          linesToUpdate[item.key] = 0;
        }
      }
    });
    if (Object.keys(linesToUpdate).length > 0) {
      console.log(`Removing lines from cart: ${JSON.stringify(linesToUpdate)}`);
      await this.removeLinesFromCart(linesToUpdate);
    }
  }

  async onClick(event) {
    event.preventDefault();

    if (this.removeVariantsBefore.length > 0) {
      await this.removeVariantsFromCart();
    }

    const variantId = this.dataset.variantId;
    const properties = this.dataset.properties ? this.parseProperties(this.dataset.properties) : {};

    if (variantId) {
      const body = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _source: this.dataset.source,
            ...properties,
          }
        }], sections: []
      };
      if (this.cartDrawerId) {
        body.sections.push(this.cartDrawerId);
      }
      if (this.cartCounterId) {
        body.sections.push(this.cartCounterId);
      }
      fetch(`${window.routes.cart_add_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .then((res) => {
          document.dispatchEvent(new CustomEvent("cart:updated"));
          if (res.sections && this.cartDrawerId && res.sections[this.cartDrawerId]) {
            document.querySelector("cart-drawer")?.refreshSections(res.sections[this.cartDrawerId]);
          } else {
            document.querySelector("cart-drawer")?.refresh();
          }
          if (res.sections && this.cartCounterId && res.sections[this.cartCounterId]) {
            document.querySelector("cart-counter")?.refreshSections(res.sections[this.cartDrawerId]);
          } else {
            document.querySelector("cart-counter")?.refresh();
          }
        });
    }
  }
}

customElements.define("quick-add-variant", QuickAddVariant);


class toggleBlockComponent extends HTMLElement {
  constructor() {
    super();
    const contentElement = this.querySelector(".toggle-block-content");
    const triggerEl = this.querySelector(".toggle-block-trigger");

    triggerEl.addEventListener("click", function() {
      contentElement.classList.toggle("!tw-hidden");
      triggerEl.classList.toggle("!tw-rotate-180");
    });
  }
}
customElements.define("toggle-block", toggleBlockComponent);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById("cart-drawer");
    this.cartCounterId = document.querySelector("cart-counter")?.dataset.sectionId;
    this.sectionId = this.dataset.sectionId;
    this.cartForm = this.querySelector("form#cart");
    
    this.querySelectorAll("[cart-drawer-close]").forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    // Open buttons (header)
    document.querySelectorAll("[cart-drawer-toggle]").forEach((button) =>
      button.addEventListener("click", this.toggle.bind(this))
    );

    this.querySelector(".overlay")?.addEventListener("click", this.close.bind(this));

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.cartForm.addEventListener("change", this.debouncedOnChange.bind(this));

  }

  toggle() {
    this.drawer.classList.toggle("active");
    if (this.drawer.classList.contains("active")) {
      document.body.classList.add("disable-page-scroll");
      document.body.classList.add("disable-page-scroll_ios");
    } else {
      document.body.classList.remove("disable-page-scroll");
      document.body.classList.remove("disable-page-scroll_ios");
    }
  }

  open() {
    this.drawer.classList.add("active");
    document.body.classList.add("disable-page-scroll");
    document.body.classList.add("disable-page-scroll_ios");
  }

  close() {
    this.drawer.classList.remove("active");
    document.body.classList.remove("disable-page-scroll");
    document.body.classList.remove("disable-page-scroll_ios");
  }

  onChange(event) {
    const input = event.target;
    if (input.name?.startsWith("quantity")) {
      if (input.dataset.relatedVariantKey) {
        const linesToUpdate = {
          [input.dataset.key]: input.value,
          [input.dataset.relatedVariantKey]: input.value
        };
        return this.massUpdateQuantity(linesToUpdate);
      } else {
        this.updateQuantity(input.dataset.key, input.value);
      }
    }
  }

  massUpdateQuantity(linesToUpdate) {
    const body = {
      updates: linesToUpdate,
      sections: [this.sectionId],
      sections_url: window.location.pathname
    };

    if (this.cartCounterId) {
      body.sections.push(this.cartCounterId);
    }

    fetch(`${window.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (res.sections && res.sections[this.sectionId]) {
          this.refreshSections(res.sections[this.sectionId]);
        } else {
          this.refresh();
        }
        if (res.sections && this.cartCounterId && res.sections[this.cartCounterId]) {
          document.querySelector("cart-counter")?.refreshSections(res.sections[this.cartDrawerId]);
        } else {
          document.querySelector("cart-counter")?.refresh();
        }
      }).catch((err) => {
        console.error(err);
      });
  }

  updateQuantity(lineKey, quantity) {

    const body = {
      id: lineKey,
      quantity,
      sections: [this.sectionId],
      sections_url: window.location.pathname
    };

    if (this.cartCounterId) {
      body.sections.push(this.cartCounterId);
    }

    fetch(`${window.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (res.sections && res.sections[this.sectionId]) {
          this.refreshSections(res.sections[this.sectionId]);
        } else {
          this.refresh();
        }
        if (res.sections && this.cartCounterId && res.sections[this.cartCounterId]) {
          document.querySelector("cart-counter")?.refreshSections(res.sections[this.cartDrawerId]);
        } else {
          document.querySelector("cart-counter")?.refresh();
        }
      }).catch((err) => {
        console.error(err);
      });
  }

  refresh(openAfterRefresh) {
    fetch(`${window.routes.root_url}?sections=${this.sectionId}`, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then((res) => res.json())
      .then((res) => {
        if (res[this.sectionId]) {
          this.refreshSections(res[this.sectionId]);
        }
        if (openAfterRefresh) {
          this.open();
        }
      });

  }

  refreshSections (freshSection) {
    const cartDrawerContainer = document.getElementById("cart-drawer-container");
    const freshCartDrawerContainer = getSectionElement(freshSection, "#cart-drawer-container");
    if (cartDrawerContainer && freshCartDrawerContainer) {
      cartDrawerContainer.className = freshCartDrawerContainer.className;
    }
    const cartDrawerLineItemsEl = document.getElementById("cart-drawer-line-items");
    const cartDrawerFooterEl = document.getElementById("cart-drawer-footer");
    const cartDrawerUpsellEl = document.getElementById("cart-drawer-upsell");
    const cartDrawerShippingProgressEl = document.getElementById("cart-drawer-shipping-progress");
    cartDrawerLineItemsEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-line-items");
    cartDrawerFooterEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-footer");
    cartDrawerUpsellEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-upsell");
    if (cartDrawerShippingProgressEl) {
      cartDrawerShippingProgressEl.innerHTML = getSectionInnerHTML(freshSection, "#cart-drawer-shipping-progress");
    }
    // Add listeners to the new footer elements
    this.querySelectorAll(".cart-drawer-close").forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

}

customElements.define("cart-drawer", CartDrawer);

class ApotechCartAutoRemoveVariant extends HTMLElement {
  constructor() {
    super();
    this.method = this.dataset.method || "cart-drawer-update";
    if (this.dataset.itemKey) {
      this.closest("cart-drawer")?.updateQuantity(this.dataset.itemKey, 0);
    }
  }

  connectedCallback() {
    this.removeVariant();
  }

  removeVariant() {
    switch (this.method) {
    case "cart-drawer-update":
      return this.removeVariantWithCartUpdate();
    case "ajax-cart-update":
      return this.removeVariantWithAjaxCartUpdate();
    default:
      return this.removeVariantWithCartUpdate();
    }
  }
  
  removeVariantWithCartUpdate() {
    this.closest("cart-drawer")?.updateQuantity(this.dataset.itemKey, 0);
  }

  removeVariantWithAjaxCartUpdate() {
    const body = {
      id: this.dataset.itemKey,
      quantity: 0,
    };

    fetch(`${window.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    })
      .then(() => {
        document.dispatchEvent(new CustomEvent("cart:updated"));
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.refresh();
        }
        const cartCounter = document.querySelector("cart-counter");
        if (cartCounter) {
          cartCounter.refresh();
        }
      }).catch((err) => {
        console.error(err);
      });
  }
}
customElements.define("apt-auto-remove-variant", ApotechCartAutoRemoveVariant);
